import { gql } from "graphql-tag";

export const CURRENCY_FIELDS = gql`
  fragment CurrencyFields on Currency {
    id
    country_id
    symbol
  }
`;

export default { CURRENCY_FIELDS };
